export const MD = '768px'
export const SM = '480px'
